import { Dialog } from 'primereact/dialog';
import React from 'react';
import styled from 'styled-components';

const StyledFullscreenDialog = styled(Dialog)<{ $contentPadding?: string }>`
  width: 100vw;
  height: 100vh;
  max-width: 100vw;
  max-height: 100vh;
  margin: 0;
  border-radius: 0;

  .p-dialog {
    border-radius: 0;
  }

  .p-dialog-content {
    padding: ${({ $contentPadding }) => $contentPadding || '0'};
    height: 100vh;
    overflow-y: auto;
    border-radius: 0;
  }

  .p-dialog-header {
    border: none;
    border-bottom: 1px solid var(--gray-light);
    padding: var(--default-padding);
    padding-bottom: var(--default-padding);
    z-index: 1000;
    cursor: default;

    .p-dialog-title {
      font-weight: normal;
    }

    .p-dialog-header-icons {
      button {
        box-shadow: none !important;

        &:focus {
          box-shadow: none !important;
        }
      }
    }
  }

  .p-dialog-footer {
    border-top: 1px solid var(--gray-dark);
    padding: var(--default-padding);
  }
`;

type FullscreenModalProps = {
  visible: boolean;
  onHide: () => void;
  children: React.ReactNode;
  contentPadding?: string;
  className?: string;
  header?: React.ReactNode;
  footer?: React.ReactNode;
};

export const FullscreenModal: React.FC<FullscreenModalProps> = ({
  visible,
  onHide,
  children,
  contentPadding,
  className,
  header,
  footer,
}) => {
  return (
    <StyledFullscreenDialog
      visible={visible}
      onHide={onHide}
      header={header}
      footer={footer}
      closable
      closeOnEscape
      blockScroll
      maximized
      className={className}
      $contentPadding={contentPadding}
    >
      {children}
    </StyledFullscreenDialog>
  );
};
